// @ts-ignore
import EXIF from 'pano-exif';
import omit from 'ramda/es/omit';

const getExifTags = (image: File) => {
  const tags = EXIF.getAllTags(image);
  return omit(['MakerNote', 'UserComment'], tags);
};

const getLng = (lng: any[], ref: string) =>
  ref === 'W'
    ? lng[0] * -1 + (lng[1] * -60 + lng[2] * -1) / 3600
    : lng[0] + (lng[1] * 60 + lng[2]) / 3600;

const getLat = (lat: any[], ref: string) =>
  ref === 'S'
    ? lat[0] * -1 + (lat[1] * -60 + lat[2] * -1) / 3600
    : lat[0] + (lat[1] * 60 + lat[2]) / 3600;

const getExif = (image: File): Promise<{ exif: string; gps: string }> => {
  return new Promise((resolve) => {
    // @ts-ignore
    EXIF.getData(image, () => {
      const exif = getExifTags(image);
      const exifJson = JSON.stringify(exif);
      if (exifJson.length > 65535) {
        resolve({
          exif: JSON.stringify({}),
          gps: JSON.stringify({}),
        });
      }
      const lngObj = EXIF.getTag(image, 'GPSLongitude');
      const lngRef = EXIF.getTag(image, 'GPSLongitudeRef');
      const latObj = EXIF.getTag(image, 'GPSLatitude');
      const latRef = EXIF.getTag(image, 'GPSLatitudeRef');
      if (lngObj && lngRef && latObj && latRef) {
        const lng = getLng(lngObj, lngRef);
        const lat = getLat(latObj, latRef);
        resolve({
          exif: JSON.stringify(exif),
          gps: JSON.stringify({ lng, lat }),
        });
      } else {
        resolve({
          exif: JSON.stringify(exif),
          gps: JSON.stringify({}),
        });
      }
    });
  });
};

export default getExif;
